<template>
    <div>
        <!--참가자1-->
        <DefaultSelfNonOpenForm v-model="playerList[0]" type="P"></DefaultSelfNonOpenForm>

        <!--참가자2-->
        <DefaultNonOpenForm v-model="playerList[1]" type="P" :check_first_player="checkFirstPlayer"></DefaultNonOpenForm>

    </div>
</template>
<script>

    import {mapState} from 'vuex'
    import participantMixin from "../../../mixins/participantMixin";

    import DefaultSelfNonOpenForm from "./DefaultSelfNonOpenForm";
    import DefaultNonOpenForm from "./DefaultNonOpenForm";
    export default {
        components: {DefaultNonOpenForm, DefaultSelfNonOpenForm},
        computed: {
        },
        mixins: [participantMixin],
        created() {
            this.playerList = [null, null]
        },
        data(){
            return{
                checkFirstPlayer: false
            }
        },
        watch: {
            playerList: function(newVal){
                if(newVal[0] === null || !newVal[0].userId ){
                    this.checkFirstPlayer = false
                }else{
                    this.checkFirstPlayer = true
                }
                this.$emit('input', newVal)
            }
        }
    }
</script>
